import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/Premium/PremiumPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/Premium/redial';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);

const PremiumPageWithProviders = withLegacyProviders(PageWithRedial);

export const PremiumPage = PremiumPageWithProviders;
